import {
    GET_SPORTS_ASSOCIATED_USERS
  } from '../actionTypes';

  const initialState = {
    sportsAssociatedUsers: [],
  };

  const dashboardReducer = (state = initialState, action) => {
    switch (action.type) {
      case GET_SPORTS_ASSOCIATED_USERS:
        return {
          ...state,
          sportsAssociatedUsers: action.payload
        };
      default: {
        return state;
      }
    }
  };
  
  export default dashboardReducer;